const SEO = [
	{
		page: "home",
		description:
			"Crafting impactful software solutions is my passion. My experience at Intuit honed my skills across the full software development lifecycle, including UI optimization, API integration, and streamlining processes. My expertise in Java and React.js fuels my drive for intuitive and user-friendly software.",
		keywords: ["Piyush", "Piyush Mittal", "Piyush Mittal Intuit"],
	},

	{
		page: "about",
		description:
			"Crafting impactful software solutions is my passion. My experience at Intuit honed my skills across the full software development lifecycle, including UI optimization, API integration, and streamlining processes. My expertise in Java and React.js fuels my drive for intuitive and user-friendly software.",
		keywords: ["Piyush", "Piyush Mittal", "Piyush Mittal Intuit"],
	},

	{
		page: "articles",
		description:
			"",
		keywords: ["Piyush", "Piyush Mittal", "Piyush Mittal Intuit"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Piyush", "Piyush Mittal", "Piyush Mittal Intuit"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Piyush", "Piyush Mittal", "Piyush Mittal Intuit"],
	},
];

export default SEO;
